import styled from 'styled-components';

export const Container = styled.div`
	min-height: 100%;
	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.body.bg.primary};
	min-width: 100%;
`;
